import { LoadingButton } from '@mui/lab';
import {
  DialogActions,
  Box,
  DialogContent,
  TextField,
  InputAdornment,
  FormControl,
  FormLabel,
  Switch,
} from '@mui/material';
import { Modal } from '@scorenco/components';
import { useTranslation, AddChallengePool } from '@scorenco/core';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { T_KEYS } from '@/translations';

type AddPoolModalProps = {
  ruleId: number;
  newRank: number;
  closeModal: () => void;
};

export const AddPoolModal = ({
  ruleId,
  newRank,
  closeModal,
}: AddPoolModalProps) => {
  const insertPoolMutation = AddChallengePool();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      nb_teams: 4,
      double: false,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        await insertPoolMutation.execute({
          ruleId,
          newRank,
          nbTeams: Number(values.nb_teams),
          double: values.double,
        });
        enqueueSnackbar(t(T_KEYS.SUCCESS_ADD), {
          variant: 'success',
        });
        closeModal();
        formik.resetForm();
      } catch (error) {
        console.error('error: ', error);
        enqueueSnackbar(t(T_KEYS.ERROR_MESSAGE), {
          variant: 'error',
        });
      }
    },
  });

  return (
    <Modal title="Ajouter une nouvelle poule" closeModal={closeModal}>
      <Box component="form" onSubmit={formik.handleSubmit}>
        <DialogContent
          style={{
            paddingTop: '1rem',
          }}
        >
          <TextField
            label={t(T_KEYS.TOURNAMENTS_RULES_NBTEAMS_LABEL)}
            value={formik.values.nb_teams}
            name="rules_rule_nb_teams"
            id="rules_rule_nb_teams"
            onChange={(event) =>
              formik.setFieldValue('nb_teams', event.target.value)
            }
            InputProps={{
              inputProps: { min: 2 },
              endAdornment: (
                <InputAdornment position="end">
                  {t(T_KEYS.TOURNAMENTS_RULES_NBTEAMS_ADORNMENT_PLURIAL)}
                </InputAdornment>
              ),
            }}
            fullWidth
            type="number"
          />
          <FormControl
            style={{
              marginTop: '1rem',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <Switch
              id="double"
              name="double"
              checked={formik.values.double}
              onChange={formik.handleChange}
            />
            <FormLabel>Double confrontation ?</FormLabel>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ m: 0, p: 1, justifyContent: 'center' }}>
          <LoadingButton
            type="submit"
            variant="contained"
            color="secondary"
            loading={insertPoolMutation.status.loading}
          >
            {t(T_KEYS.ADD)}
          </LoadingButton>
        </DialogActions>
      </Box>
    </Modal>
  );
};
